import './styles/@theme';
import type { Game } from '@/types/games';
import type { Region } from '@/types/constants';
import { parseGamesList } from '@/logic/games/parse-games-list';
import { GameFactoryClient } from '@/app/components/game/game-factory.client';
import { PRISMIC_ZONE_LAYOUT } from '@/app/constants/zone';

interface GameCardProps {
    games: Game[];
    gtmConfig?: Record<string, unknown>;
    region?: string;
    isMobile?: boolean;
    forceTextBadge?: boolean;
}

export const GameCard = ({ games, region = 'CT', isMobile = true, forceTextBadge = false }: GameCardProps) => {
    const { games: adaptedGames } = parseGamesList(games, PRISMIC_ZONE_LAYOUT.ONE_ROW, {
        region: region as Region,
        isMobile
    });

    return (
        <div className="games-card">
            <div className="inner-card">
                {adaptedGames.map((game) => (
                    <div className="game-tile" key={game.uid}>
                        <GameFactoryClient
                            game={game}
                            gameType="simplified-row"
                            layout={PRISMIC_ZONE_LAYOUT.ONE_ROW}
                            forceTextBadge={forceTextBadge}
                            hideGameInfo={true}
                            tracking={{ gamePosition: null }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};
